const BASE = 'tn-btn-datepicker';
const BTN_PERIOD = `${BASE}__btn-period-prev-next`;

export default {
  BASE,
  BTN_PERIOD,
  BTN_PERIOD_PREV: `${BTN_PERIOD}--btn-prev`,
  BTN_PERIOD_NEXT: `${BTN_PERIOD}--btn-next`,
};
